// extracted by mini-css-extract-plugin
module.exports = {"backButton":"BackButton_backButton__1Nbil","chevronIcon":"BackButton_chevronIcon__2di35"};